import { createContext } from 'react'

export const LoqateContext = createContext({
    label: 'Address Line 1',
    name: 'addressLine1',
})
